import React from 'react';
import styled from 'styled-components';
import { theme } from '../../config/theme';
import { isVideo } from './Media';

// Styled components for modal images
const ModalImage = styled.img`
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  border: 1px solid ${theme.shadows.light};
`;

// Styled components for modal videos
const ModalVideo = styled.video`
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  border: 1px solid ${theme.shadows.light};
`;

// Modal media component for full-screen viewing
const ModalMedia = ({ 
  src, 
  alt,
  autoPlay = true,
  loop = true,
  muted = true,
  playsInline = true,
  controls = true, // Enable controls in modal for better UX
  ...props 
}) => {
  if (isVideo(src)) {
    return (
      <ModalVideo
        src={src}
        autoPlay={autoPlay}
        loop={loop}
        muted={muted}
        playsInline={playsInline}
        controls={controls}
        aria-label={alt}
        {...props}
      />
    );
  }

  return (
    <ModalImage
      src={src}
      alt={alt}
      {...props}
    />
  );
};

export default ModalMedia;